import packagejson from '../package.json';

export const CLIENT_VERSION = packagejson.version;
export const REACT_VERSION = packagejson.dependencies.react;

const ENVIRONMENTS = {
    cdc: {
        apiUrl: "/api",
        showBuildInfo: false
    },
    development: {
        apiUrl: "/api",
        showBuildInfo: true
    },
    local: {
        apiUrl: "/api",
        showBuildInfo: false
     }
}

// TODO to run locally, change local to
//    local: {
//         apiUrl: "http://127.0.0.1:5000/api",
//         showBuildInfo: true
//      }

// TODO to build for production, change local: to
//     local: {
//         apiUrl: "/api",
//         showBuildInfo: false
//     }
// TODO afterwards run react-csp prod && react-scripts --openssl-legacy-provider build

export const CURRENT_ENVIRONMENT = ENVIRONMENTS[process.env.REACT_APP_DEPLOY_ENV ? process.env.REACT_APP_DEPLOY_ENV : 'local']

const MAX_COMMIT_CHARS = 8;
export const GIT_COMMIT = process.env.REACT_APP_GIT_COMMIT ?
	process.env.REACT_APP_GIT_COMMIT.slice(0, MAX_COMMIT_CHARS) : '';
export const BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER ?
	process.env.REACT_APP_BUILD_NUMBER : '';
